import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const guides = [{
  id: 'G1',
  title: 'EMPEZÁ CON LO QUE TENÉS',
  subtitle: 'Del sueño al primer paso real',
  points: ['Los 3 modelos de arranque según tu capital disponible hoy', 'Inventario de activos: lo que ya tenés y cómo usarlo para arrancar', 'Los 5 errores que cometen el 90% de las que empiezan', 'Tu plan de acción de los primeros 7 días', 'Metas reales del primer mes en pesos argentinos']
}, {
  id: 'G2',
  title: 'DÓNDE Y CÓMO CONSEGUIR TU MERCADERÍA',
  subtitle: 'Comprás con criterio, vendés con ganancia',
  points: ['Cómo funciona la cadena mayorista en Argentina (Once, La Salada, Flores)', 'Las 7 preguntas para evaluar un proveedor antes de comprarle', 'Cómo armar tu primera orden de compra sin quedarte con stock muerto', 'Negociá como una profesional: precio de contado y por volumen', 'Proveedores online confiables que envían a todo el país']
}, {
  id: 'G3',
  title: 'TU VIDRIERA DIGITAL',
  subtitle: 'Vendé por Instagram sin miles de seguidores',
  points: ['Cómo configurar tu perfil como una tienda que genera confianza', 'Fotografía profesional con el celular: luz, ángulos y edición gratis', 'Qué publicar cada día sin agotarte ni bloquearte', 'El guión de ventas por DM: respuesta exacta para cada situación', 'WhatsApp Business como segundo canal de ventas activo']
}, {
  id: 'G4',
  title: 'TUS NÚMEROS, TU NEGOCIO',
  subtitle: 'Sabés exactamente cuánto ganás cada mes',
  points: ['El método de 3 pasos para calcular el precio correcto', 'Los 6 costos ocultos que te comen la ganancia sin que lo notes', 'Sistema de 3 cuentas para separar la plata del negocio', 'Planilla semanal de ventas y gastos: 10 minutos cada viernes', 'Las 4 métricas mensuales que te dicen si crecés de verdad']
}, {
  id: 'G5',
  title: 'TU SHOWROOM, TU MARCA',
  subtitle: 'Experiencia que fideliza desde la primera visita',
  points: ['Showroom profesional en cualquier espacio con menos de $30.000', 'Los 5 sentidos que hacen que tu clienta quiera quedarse y volver', 'Sistema de turnos para recibir clientas sin que consuma tu vida', 'El guión de atención de 5 momentos que dispara la fidelización', 'Identidad de marca: nombre, colores, hashtag y estilo propio']
}, {
  id: 'G6',
  title: 'DE VENTA EN VENTA A NEGOCIO DE VERDAD',
  subtitle: 'Sistema, temporadas y plan de 90 días',
  points: ['La diferencia entre tener ventas y tener un negocio', 'Tu semana organizada en 4 bloques para que el negocio no te consuma', 'El calendario de temporadas en Argentina: cuándo comprar y cuándo liquidar', 'Las señales de que llegó el momento de delegar', 'Tu plan de acción personalizable para los próximos 90 días']
}, {
  id: 'G7',
  title: 'CLIENTAS PARA SIEMPRE',
  subtitle: 'Cartera que compra, vuelve y te recomienda',
  points: ['Los 4 tipos de clienta y cómo tratarlas para que vuelvan siempre', 'Sistema de registro: el activo más valioso de tu negocio', 'Lista VIP de WhatsApp: cómo usarla sin parecer spam', 'Cómo pedir referidos sin incomodarte — las palabras exactas', 'Recuperar clientas inactivas: el mensaje que funciona']
}, {
  id: 'G8',
  title: 'DE EMPRENDEDORA A DUEÑA',
  subtitle: 'Tu propia marca, producción y red de revendedoras',
  points: ['Cuándo y cómo pasar de revender a producción propia', 'Talleristas, moldería y primera colección con presupuesto real', 'Red de revendedoras bajo tu marca: reclutar, capacitar y sostener', 'Local físico: los números reales antes de firmar un alquiler', 'Tu plan de 12 meses hacia el siguiente nivel']
}];
export function GuidesAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/20" data-id="element-120">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-122">
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-123">
            LAS 8 GUÍAS
          </h2>
          <p className="text-sm sm:text-base text-violet-100/70 mb-1 sm:mb-2" data-id="element-124">
            Tu hoja de ruta para dominar el negocio de la moda
          </p>
          <p className="text-xs sm:text-sm text-gold" data-id="element-125">
            Tocá cada guía para ver lo que incluye 👆
          </p>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-126">
          {guides.map((guide, index) => <motion.div key={guide.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`border rounded-lg overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-violet-rich/40 border-gold/40' : 'bg-violet-deep/60 border-gold/20 hover:border-gold/40'}`} data-id="element-127">
              <motion.button whileTap={{
            scale: 0.99
          }} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 sm:px-6 sm:py-5 flex items-center justify-between text-left" data-id="element-128">
                <div className="flex-1 pr-4" data-id="element-129">
                  <div className="flex items-center gap-2 sm:gap-3 mb-1" data-id="element-130">
                    <span className="text-gold font-semibold text-xs sm:text-sm" data-id="element-131">
                      {guide.id}
                    </span>
                    <span className="text-white font-semibold text-sm sm:text-base" data-id="element-132">
                      {guide.title}
                    </span>
                  </div>
                  <p className="text-violet-100/70 text-xs sm:text-sm" data-id="element-133">
                    {guide.subtitle}
                  </p>
                </div>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-134" />
              </motion.button>

              <AnimatePresence data-id="element-135">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-136">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-5 border-t border-gold/10 pt-3 sm:pt-4" data-id="element-137">
                      <ul className="space-y-2" data-id="element-138">
                        {guide.points.map((point, i) => <li key={i} className="flex gap-2 sm:gap-3 text-xs sm:text-sm text-violet-100/80" data-id="element-139">
                            <span className="text-gold mt-0.5" data-id="element-140">→</span>
                            <span data-id="element-141">{point}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}